<template>
  <div>
    <el-dialog :title="parentINFO.tit" :visible.sync="dialogFormVisible" width="500px" center class="elform2" :close-on-click-modal="false" @close="closeDialog">
      <div v-loading="loading" class="exportDetail">
        <div class="contant">
          <div class="wraper">
            <div :class="[str=='a'?'left':'right','com']" @click="btnclick('a')">{{leftMess}}</div>
            <div :class="[str=='b'?'left':'right','com']" @click="btnclick('b')">{{rightMess}}</div>
          </div>
        </div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="75px" style="margin-top: -30px;" v-if="str=='b'">
          <el-form-item :label="label" prop="name">
            <el-date-picker size="small" type="month" value-format="yyyy-MM" placeholder="选择日期" @change="kkkk"
            v-model="ruleForm.datess" style="width: 200px;" :picker-options="expireTimeOption"></el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button style="width: 120px;background: #9B9B9B;border: none;" size="small" type="primary" @click="closeDialog">取 消</el-button>
          <el-button  style="width: 120px;background: #269D7B;border: none;" size="small" type="primary" @click="bankNumbers">确 定</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="未生成电子回单" :visible.sync="show2" width="500px" center class="elform2" :close-on-click-modal="false">
      <div v-loading="loading2" class="exportDetail">
        <div class="contant">
          有流水未生成电子回单。<br/>
          电子回单完全生成后才能下载或打印。<br/>
          是否立即生成电子回单？
        </div>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button style="width: 120px;background: #9B9B9B;border: none;" size="small" type="primary" @click="show2 = false">取 消</el-button>
          <el-button style="width: 120px;background: #269D7B;border: none;" size="small" type="primary" @click="generation">立即生成</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="生成电子回单" :visible.sync="show3" width="500px" center class="elform2" :close-on-click-modal="false">
        <div class="contant" v-if="parentINFO.type=='a'">
          生成完成。<br/>
          可立即下载或打印电子回单。
        </div>
        <div class="contant" v-else>
          已成功向银行申请生成电子回单。<br/>
          请五分钟后刷新页面查看生成进度。
        </div>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button style="width: 120px;background: #9B9B9B;border: none;" size="small" type="primary" @click="show3 = false">取 消</el-button>
          <el-button style="width: 120px;background: #269D7B;border: none;" size="small" type="primary" @click="show3 = false">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
  import axios from 'Axios'
  import qs from 'qs'
  export default {
    props: ['visible'],
  	data(){
  		return {
        loading:false,
        loading2:false,
        dialogFormVisible:false,
        show2:false,
        show3:false,
        hrefs:'',
        str:'a',
        blen:'',
        expireTimeOption:{},
        parentINFO:{
          type:'',
          title:'',
        },
        ukparm:{
          parm:'',
          url:'',
        },
        leftMess:'',
        rightMess:'',
        label:'',
        ruleForm:{
          datess:''
        }
  		}
  	},

  	computed: {

  	},
  	methods:{
      kkkk(val){

      },
      closeDialog(){
        this.dialogFormVisible=false
        this.$emit('refresh',false)
      },
      btnclick(val){
        this.str=val
        if(val=='a'){
          this.ruleForm.datess=''
        }
      },
      typelist(type){
        if(type=='a'){
          this.leftMess='生成所选电子回单'
          this.rightMess='生成月度电子回单'
          this.label='生成月份:'
        }else if(type=='b'){
          this.leftMess='下载所选电子回单'
          this.rightMess='下载月度电子回单'
          this.label='下载月份:'
        }else if(type=='c'){
          this.leftMess='打印所选电子回单'
          this.rightMess='打印月度电子回单'
          this.label='打印月份:'
        }else{
          this.leftMess='导出所选明细'
          this.rightMess='导出月度明细'
          this.label='导出月份:'
        }
      },
      bankNumbers(){
        let parm=''
        let arr=[]
        if(this.str=='a'){
          if(this.parentINFO.selrows&&this.parentINFO.selrows.length>0){
            this.parentINFO.selrows.forEach((item)=>{
              arr.push(item.serialNo)
            })
            parm={serialNos:arr.join(',')},
            this.conmonfunc(parm)
          }else{
            this.$message.error('你还没选择银行流水，请先选择银行流水');
          }
        }else{
          parm={queryMonth:this.ruleForm.datess,bankNo:this.visible.bankNo},
          this.conmonfunc(parm)
        }
      },
      conmonfunc(parm){
        let URL=""
        if(this.parentINFO.type=='a'){//生成
          parm.bankNo=this.parentINFO.bankNo
          URL='/bankStatement/getReceipt'
          this.confirmNumbers(URL,parm)
        }else if(this.parentINFO.type=='b'){//下载
          URL='bankStatement/downReceiptPDF'
          this.checksign(parm,URL)
        }else if(this.parentINFO.type=='c'){//打印
          URL='bankStatement/printReceiptPDF'
          this.checksign(parm,URL)
        }else{//导出
          URL='/bankStatement/exportStatement'
          this.confirmNumbers(URL,parm)
        }
      },
      checksign(parm,URL){//检查所选流水是否都生成了回单
        this.loading=true
        this.$http.post('/bankStatement/checkPDF',parm).then((res)=>{
          this.loading=false
          if(res && res.data.code == '1'){
            this.dialogFormVisible=false
            this.blen=res.data.data
            this.confirmNumbers(URL,parm)
          }else if(res && res.data.code == '4'){
            this.blen=false
          }else{
            this.blen=false
            this.dialogFormVisible=false
            this.show2=true
            parm.serialNos=res.data.msg
            this.ukparm.parm=parm
            this.ukparm.url='/bankStatement/getReceipt'
          }
        })
      },
      generation(){//立即生成电子回单-----------未生成的时候
        this.loading2=true
        this.$http.post(this.ukparm.url,this.ukparm.parm).then((res)=>{
          this.loading2=false
          if(res && res.data.code == '1'){
            this.dialogFormVisible=false
            this.show2=false
            this.show3=true
            this.$emit('clearSelect')
          }
        })
      },
      confirmNumbers(url,parm){
        let baseURL=this.$rootUrl;
        let token = sessionStorage.getItem('token')
        let cid = sessionStorage.getItem('cid')
        let newUrl=baseURL+url+'?token='+token+'&cid='+cid+"&"+qs.stringify(parm,{arrayFormat: 'indices', allowDots: true})
        if(this.parentINFO.type=='a'){//--------------生成电子回单
          this.loading=true
          this.$http.post(url,parm).then((res)=>{
            this.loading=false
            if(res && res.data.code == '1'){
              this.dialogFormVisible=false
              this.show2=false
              //this.show3=true
              this.$emit('clearSelect');
              this.$message.success(res.data.msg);
            }
          })
        }else if(this.parentINFO.type=='c'){//--------打印电子回单
          const router = this.$router.resolve({
            path: url,
            query: parm
          })
          window.open(this.$rootUrl + router.href, '_blank');
          this.dialogFormVisible=false
          this.show2=false
          //this.show3=false
          this.$emit('clearSelect')
          // this.$message.success(res.data.msg);
        }else{//-------------------------------------导出交易流水和下载电子回单
          if(newUrl){
            window.open(newUrl,"_blank")
          }
          this.dialogFormVisible=false
          this.show2=false
          this.show3=false
          this.$emit('clearSelect')
        }
      },
  	},
    watch: {
  　　visible: {
　　　　handler(newValue, oldValue) {
          if(newValue.showdialog){
            this.str='a'
            this.ruleForm.datess=''
            this.dialogFormVisible=true;
            this.parentINFO=newValue;

            this.expireTimeOption={
              disabledDate(date) {
                var Tdate = new Date();
                var Bdate = new Date(newValue.signDate);
                return date.getTime() < Bdate.getTime() || new Date(Tdate.getFullYear(),Tdate.getMonth(),0).getTime() <= new Date(date.getFullYear(),date.getMonth(),0).getTime();
              }
            }
            this.typelist(newValue.type)
          }
　　　　},
　　　　deep: true,
       immediate: true
  　　},

    }
  }
</script>

<style lang="less" scoped>
  .exportDetail{
    .contant{
      display: flex;justify-content: center;
      margin-bottom: 63px;
      .wraper{
        display: flex;justify-content: space-between;width: 450px;
        .com{
          width:200px;
          height:100px;
          border-radius:5px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          cursor: pointer;
        }
        .left{
          background: #269D7B;
          color: white;
        }
        .right{
          background: #FCFCFC;
          border: 1px dashed #D9D9D9;
          color: #4A4A4A;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/bankwater/exportdetail.vue